function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Row, Container, Col } from 'react-bootstrap';
import { Skeleton, message, Button, Modal, Drawer, Descriptions, Space } from 'antd';
import NewCustomer from "../components/forms/NewCustomer";
import { Input } from 'antd';
import Common from "../components/includes/Common";
import { PersonFillAdd, PieChart, PersonFillUp, XSquareFill } from 'react-bootstrap-icons';
import moment from "moment";
import ExecOrder from "../components/forms/ExecOrder";
import PatientView from "../components/PatientView";
import { Excel } from "antd-table-saveas-excel";
import CashierTransactionsList from "../components/CashierTransactionsList";
import RegisterPatient from "../components/forms/RegisterPatient";
import ForwardPatient from "../components/forms/ForwardPatient";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var Cashier = function Cashier() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCustomer = _useState2[0],
    setSelectedCustomer = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    dataChanged = _useState4[0],
    setDataChanged = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    customers = _useState8[0],
    setCustomers = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    execDrawerVisible = _useState10[0],
    setExecDrawerVisible = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isReportModalOpen = _useState12[0],
    setIsReportModalOpen = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    newCustomerCreated = _useState14[0],
    setNewCustomerCreated = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isPatientModalOpen = _useState16[0],
    setIsPatientModalOpen = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    searchId = _useState18[0],
    setSearchId = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    totalCash = _useState20[0],
    setTotalCash = _useState20[1];
  var _useState21 = useState(moment().startOf('day').format()),
    _useState22 = _slicedToArray(_useState21, 2),
    from = _useState22[0],
    setFrom = _useState22[1];
  var _useState23 = useState(moment().endOf('day').format()),
    _useState24 = _slicedToArray(_useState23, 2),
    to = _useState24[0],
    setTo = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    billsArrayData = _useState26[0],
    setBillsArrayData = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    isNpVisible = _useState28[0],
    setIsNpVisible = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isForwardVisible = _useState30[0],
    setIsForwardVisible = _useState30[1];
  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx("b", {
        children: date
      });
    },
    key: "date"
  }, {
    title: "Patient/ETS",
    dataIndex: "patient",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "patient"
  }, {
    title: "Type",
    dataIndex: "type",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "type"
  }, {
    title: "Acte (s)",
    dataIndex: "acte",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "acte"
  }, {
    title: "Total (GNF)",
    dataIndex: "total",
    key: "total"
  }];
  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };
  var handleUpdate = function handleUpdate() {
    setNewCustomerCreated(true);
    setDataChanged(true);
  };
  var onSearch = function onSearch(v) {
    if (v.length > 0) {
      setSearchId(v);
      setIsPatientModalOpen(true);
    }
  };
  var handleOrder = function handleOrder(c) {
    setSelectedCustomer(c);
    setExecDrawerVisible(true);
  };
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getdailycash/' + Common.currentUser.id.toString())]).then(function (response) {
      setIsDataLoading(false);
      if (response[0].data.status == 200) {
        setCustomers(response[0].data.customers);
      }
      if (response[1].data.status == 200) {
        setTotalCash(response[1].data.totalCash);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  }, [newCustomerCreated, dataChanged, from, to]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 5,
        md: 6,
        children: /*#__PURE__*/_jsx("div", {
          className: "white-txt cool-radius",
          style: {
            background: "#CCBFB0"
          },
          children: /*#__PURE__*/_jsx(NewCustomer, {
            handleUpdate: handleUpdate
          })
        })
      }), /*#__PURE__*/_jsxs(Col, {
        lg: 7,
        md: 6,
        children: [/*#__PURE__*/_jsx(Search, {
          placeholder: "Entrez ID ou Telephone",
          size: "large",
          onSearch: onSearch,
          enterButton: true,
          style: {
            width: '100%',
            marginBottom: '20px'
          }
        }), /*#__PURE__*/_jsxs("div", {
          className: "white-bg cool-radius",
          style: {
            background: '#90877C',
            color: '#EEE',
            minHeight: '250px'
          },
          children: [!isDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsxs(Descriptions, {
              bordered: true,
              title: /*#__PURE__*/_jsx("div", {
                style: {
                  color: '#EEE'
                },
                children: "RESUME JOURNEE"
              }),
              size: "small",
              contentStyle: {
                background: 'none',
                color: '#EEE'
              },
              labelStyle: {
                background: 'none',
                color: '#EEE',
                fontWeight: 'bold'
              },
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Total Nouveaux patients",
                children: customers.length
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Total Convention\xE9s",
                children: customers.filter(function (customer) {
                  return customer.category == 1;
                }).length
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Total Particuliers",
                children: customers.filter(function (customer) {
                  return customer.category == 0;
                }).length
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: "Total Cash",
                children: [totalCash.toLocaleString('en'), " GNF"]
              })]
            })
          }) : /*#__PURE__*/_jsx(Skeleton, {
            active: true
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx(Button, {
          block: true,
          type: "primary",
          onClick: function onClick() {
            return setIsReportModalOpen(true);
          },
          style: {
            background: "#34C482"
          },
          icon: /*#__PURE__*/_jsx(PieChart, {
            size: 28
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "VOIR RAPPORT"
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              children: /*#__PURE__*/_jsx(Button, {
                block: true,
                type: "primary",
                onClick: function onClick() {
                  setIsNpVisible(true);
                },
                style: {
                  background: "#AA3435"
                },
                icon: /*#__PURE__*/_jsx(PersonFillAdd, {
                  size: 28
                }),
                children: /*#__PURE__*/_jsx("b", {
                  children: "AJOUTER UN PATIENT"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              children: /*#__PURE__*/_jsx(Button, {
                block: true,
                type: "primary",
                onClick: function onClick() {
                  setIsForwardVisible(true);
                },
                style: {
                  background: "#ECB440"
                },
                icon: /*#__PURE__*/_jsx(PersonFillUp, {
                  size: 28
                }),
                children: /*#__PURE__*/_jsx("b", {
                  children: "TRANSFERER UN PATIENT"
                })
              })
            })]
          })
        }), /*#__PURE__*/_jsx("br", {})]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      title: "Infos patient",
      destroyOnClose: true,
      footer: null,
      visible: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      width: "90%",
      children: /*#__PURE__*/_jsx(PatientView, {
        pid: searchId
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      destroyOnClose: true,
      visible: isReportModalOpen,
      headerStyle: {
        background: '#F08A8D',
        borderRadius: '0px'
      },
      width: "90%",
      onClose: function onClose() {
        setIsReportModalOpen(false);
      },
      footer: null,
      title: /*#__PURE__*/_jsx("b", {
        children: "RAPPORT DU JOUR"
      }),
      children: /*#__PURE__*/_jsx(CashierTransactionsList, {
        dataChanged: dataChanged
      })
    }), /*#__PURE__*/_jsx(Modal, {
      visible: isNpVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "NOUVEAU PATIENT"
      }),
      onCancel: function onCancel() {
        setIsNpVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(RegisterPatient, {
        handler: function handler() {
          setIsNpVisible(false);
          message.success({
            content: 'Patient enregistré(e)'
          });
        }
      })
    }), /*#__PURE__*/_jsx(Modal, {
      visible: isForwardVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "TRANSFERER UN PATIENT"
      }),
      onCancel: function onCancel() {
        setIsForwardVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(ForwardPatient, {
        handler: function handler() {
          setIsForwardVisible(false);
        }
      })
    })]
  });
};
export default Cashier;